import React from "react";
import { HelpContent } from "../../../../application/domain/help/help-entity";
import { Link } from "@graffer-inc/console-design-kit";
import "./contents-heading-list.scss";
import { useContentsHeadingListController } from "./use-contents-heading-list-controller";

type ContentsHeadingListProps = {
  content: HelpContent;
};

export const ContentsHeadingList: React.FC<ContentsHeadingListProps> = ({
  content,
}) => {
  const { headings } = useContentsHeadingListController(content);

  return (
    <>
      {headings.length > 0 && (
        <div className={"help-contents-heading-list-container"}>
          <p className="help-contents-heading-title">目次</p>
          <ul className="help-contents-heading-list">
            {headings.map((heading, index) => (
              <>
                {heading.text && (
                  <li
                    key={index}
                    style={{ marginLeft: `${(heading.level - 1) * 20}px` }}
                  >
                    <Link
                      anchor={(props) => (
                        <a {...props} href={`#${heading.text}`}>
                          {heading.text}
                        </a>
                      )}
                    >
                      {heading.text}
                    </Link>
                  </li>
                )}
              </>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};
